import FieldHandlerFactory from './FieldHandlerFactory';

// Re-export utilities that were previously in the main file
export { parseFormulaFields, preloadAttachmentFiles } from './utils';

/**
 * Dynamic Field Configuration Mapping (Refactored)
 *
 * This function maps field configurations using a factory pattern with specialized handlers
 * for different field types. This approach follows EPC principles:
 *
 * - Extensible: Easy to add new field types by creating new handlers
 * - Performant: Optimized lookups and reduced cyclomatic complexity
 * - Consistent: Unified interfaces and standardized patterns
 *
 * @param {Object} baseConfig - Dynamic field base configuration
 * @param {Array<Object>} [configData] - Fields base configuration list
 * @param {Boolean} [dependency] - Enable field dependencies
 * @returns {Object} Field configuration object
 */
export function fieldConfigurationMapping(baseConfig, configData = [], dependency = true) {
  if (!baseConfig || !baseConfig.type) {
    throw new Error('Invalid baseConfig: type is required');
  }

  try {
    const handler = FieldHandlerFactory.getHandler(
      baseConfig.type,
      baseConfig,
      configData,
      dependency,
    );

    return handler.handle();
  } catch (error) {
    console.error('Error in fieldConfigurationMapping:', error);
    // Fallback to basic configuration to prevent complete failure
    return {
      type: 'text',
      knownType: baseConfig.type,
      name: baseConfig.internalName,
      label: baseConfig.displayText,
      value: baseConfig.value || baseConfig.defaultValue,
      rules: [{ required: dependency ? !!baseConfig.required : false }],
    };
  }
}
